import React, { ReactNode, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Row, Col, Flex, Image, Modal } from 'antd';
import './WorkOrderCardUI.scss';
import Label from '@/components/Label';
import IssueApi from '@/fetch/bussiness/issue';
import { IssueType, IssueStatus, CLSTAG } from '@/utils/constant';
import IssueStatusIcon from '@/components/IssueStatusIcon';
import RenderBottomBtn from './RenderBottomBtn';
import AccidentOrderAddModal from '@/components/AccidentOrderAddModal';
import { enumTranslator } from '@/utils';
import { request } from '@/fetch/core';
import {
  formatTimeStamp,
  transIssueDurationTime,
  formatCurDateTime,
  clstagStr,
} from '@/utils/util';
import IssueVideo from './IssueVideo';
import { convertSpeedMsToKmh } from '@/utils/util';
import CreateFollowupGroup from '../CreateFollowupGroup';

export const FieldItem = React.memo(
  ({
    label,
    value,
    show = true,
    labelStyle,
  }: {
    label: string;
    value: ReactNode;
    show?: boolean;
    labelStyle?: any;
  }) => {
    return show ? (
      <Row className="work-order-card-field" align="middle">
        <Col className="label" style={{ ...labelStyle }}>
          {label}
        </Col>
        <Col className="value">{value}</Col>
      </Row>
    ) : (
      ''
    );
  }
);

const WorkOrderRecord = ({
  recordList,
}: {
  recordList: { reportTime: string; description: string }[];
}) => {
  return (
    <div className="work-order-record">
      {recordList?.map((item, index) => {
        return (
          <div className="record" key={item.reportTime + index}>
            <i className="icon"></i>
            <span className="time">{formatTimeStamp(item.reportTime)}</span>
            <span className="msg">{item.description}</span>
            {index < recordList.length - 1 && <hr className="connect" />}
          </div>
        );
      })}
    </div>
  );
};

const WorkOrderCardUI = ({
  info,
  magnifyVehicleName,
  isDrawerOpen,
}: {
  info: any;
  magnifyVehicleName: string;
  isDrawerOpen: boolean;
}) => {
  const fetchApi = new IssueApi();
  const [unfold, setUnfold] = useState<boolean>(true);
  const [issueDuration, setIssueDuration] = useState<string>('-');
  const [accidentModelVisible, setAccidentModelVisible] = useState(false);
  let durationTime = new Date().getTime() - info.issueStartTime;
  const { cockpitTeamNumber, currentCockpit } = useSelector(
    (state: any) => state.cockpitInfo
  );

  useEffect(() => {
    let timer: any = null;
    timer = setInterval(() => {
      durationTime = durationTime + 1000;
      const t = transIssueDurationTime(durationTime);
      setIssueDuration(t);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [info.vehicleName, info.issueStartTime]);

  const changeUnfoldStatus = () => {
    setUnfold(!unfold);
  };

  const renderEvent = () => {
    return (
      <Flex>
        {info.issueEventList?.map((item: any) => {
          return (
            <Label text={enumTranslator('ALARM_EVENT_ENUM', item.eventType)} />
          );
        })}
      </Flex>
    );
  };

  const renderMedia = (mediaList: any[]) => {
    return (
      <>
        {mediaList?.map((v: any) => {
          return v.type === 'image' && v.url ? (
            <Image
              src={v.url}
              style={{ height: '60px', width: '60px' }}
            ></Image>
          ) : v.type === 'video' && v.url ? (
            <i
              onClick={() => {
                Modal.info({
                  width: 800,
                  title: '视频预览',
                  closable: true,
                  footer: null,
                  content: <video src={v.url} controls height={600} />,
                });
              }}
              style={{
                height: '60px',
                width: '60px',
                display: 'block',
                backgroundColor: '#000',
              }}
            ></i>
          ) : (
            '-'
          );
        })}
      </>
    );
  };

  const renderOPSMedia = () => {
    if (unfold) {
      return (
        <>
          <FieldItem
            label="补充照片"
            value={renderMedia(info.manualAlarmRecordAttachmentList)}
          />
        </>
      );
    }
  };

  const renderVideoPic = () => {
    if (info.issueType === IssueType.OPS && unfold) {
      return (
        <IssueVideo
          vehicleName={info.vehicleName}
          magnifyVehicleName={magnifyVehicleName}
        />
      );
    } else if (info.issueType === IssueType.PROBLEM_REPORT) {
      return (
        <>
          <FieldItem
            label="补充照片"
            value={renderMedia(info.bugReport?.attachmentList)}
          />
        </>
      );
    } else {
      return <></>;
    }
  };

  const goToSingle = () => {
    if (info.newIssue) {
      fetchApi.cancelNewIssue(
        [info?.issueNumber],
        currentCockpit.cockpitNumber
      );
    }
    window.open(
      `/app/single?license=${info?.vehicleName}&tabKey=threeDimension&source=ticket`,
      '_blank'
    );
  };
  return (
    <div className="work-order-card-container" key={info.issueNumber}>
      <div
        className={classNames('vehicle-name-container', {
          redbg:
            info.issueReminder || info.emergencyIssue || info.reportReminder,
        })}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            className="vehicle-name"
            onClick={goToSingle}
            clstag={clstagStr(CLSTAG.IssueCardToSingle)}
          >
            {info.vehicleName}
          </span>
          <span
            className="station-name"
            style={{
              maxWidth:
                info.reportReminder && info.issueReminder ? '62px' : '112px',
            }}
          >
            {info.stationName}
          </span>
          {info.reportReminder && (
            <img
              className="report-reminder-icon"
              src={require('@/assets/img/cockpit/report-reminder-icon.png')}
            />
          )}
          {info.issueReminder && (
            <img
              className="hasten-icon"
              src={require('@/assets/img/cockpit/hasten_icon.png')}
            />
          )}
        </div>
        <IssueStatusIcon
          status={info.emergencyIssue ? 'urgent' : info.issueStatus}
        />
      </div>

      <div className="work-order-info-container">
        <FieldItem
          labelStyle={{ height: '24px' }}
          label="事件"
          value={renderEvent()}
        />
        {unfold &&
          info.issueType === IssueType.OPS &&
          info.issueEventRecordList?.length > 0 && (
            <WorkOrderRecord recordList={info.issueEventRecordList} />
          )}
        <FieldItem label="工单持续时间" value={issueDuration} />
        <FieldItem
          show={info.issueType === IssueType.PROBLEM_REPORT}
          label="发生问题时间"
          value={
            info.bugReport?.startTime
              ? `${formatCurDateTime(
                  new Date(info.bugReport?.startTime),
                  true
                )}-${formatCurDateTime(
                  new Date(info.bugReport?.endTime),
                  true
                )}`
              : '-'
          }
        />
        <Row>
          <Col span={12}>
            <FieldItem
              show={info.issueType === IssueType.OPS}
              label="配送状态"
              value={
                enumTranslator('SCHEDULE_STATE_ENUM', info.scheduleState) ?? '-'
              }
            />
          </Col>
          <Col span={12}>
            <FieldItem
              label="系统状态"
              show={info.issueType === IssueType.OPS}
              value={
                enumTranslator('SYSTEM_STATE_ENUM', info.systemState) ?? '-'
              }
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <FieldItem
              label="车辆模式"
              show={info.issueType === IssueType.OPS}
              value={
                enumTranslator('VEHICLE_STATE_ENUM', info.vehicleState) ?? '-'
              }
            />
          </Col>
          <Col span={12}>
            <FieldItem
              label="速度"
              show={info.issueType === IssueType.OPS}
              value={convertSpeedMsToKmh(info.speed, 1)}
            />
          </Col>
        </Row>
        <FieldItem
          show={info.issueType === IssueType.PROBLEM_REPORT}
          label="问题描述"
          value={info.bugReport?.description ?? '-'}
        />
        {isDrawerOpen && renderOPSMedia()}
        {[IssueStatus.PROCESS, IssueStatus.ON_HOLD].includes(
          info.issueStatus
        ) &&
          isDrawerOpen &&
          renderVideoPic()}
      </div>
      <div className="order-action-btns">
        <div
          className="order-btn"
          onClick={() => setAccidentModelVisible(true)}
        >
          创建事故单
        </div>
        <CreateFollowupGroup issueInfo={info} />
      </div>
      <div className="bottom-btns">
        <RenderBottomBtn issueInfo={info} />
      </div>

      {info.issueType === IssueType.OPS &&
        [IssueStatus.PROCESS, IssueStatus.ON_HOLD].includes(
          info.issueStatus
        ) && (
          <div
            className="card-bottom-btn"
            onClick={changeUnfoldStatus}
            clstag={clstagStr(CLSTAG.IssueCardExpandFold)}
          >
            <span>{unfold ? '收起' : '展开'}</span>
            <img
              src={
                unfold
                  ? require('@/assets/img/cockpit/fold_icon.png')
                  : require('@/assets/img/cockpit/unfold_icon.png')
              }
            />
          </div>
        )}
      {accidentModelVisible && (
        <AccidentOrderAddModal
          vehicleName={info?.vehicleName}
          issueNumber={info?.issueNumber}
          onCancel={() => setAccidentModelVisible(false)}
        />
      )}
    </div>
  );
};

export default React.memo(WorkOrderCardUI);
